import stringsToSymbols from "@/util/strings-to-symbols.mjs";
import SymbolMap from "@/util/symbol-map.mjs";

// When the mode is no longer available
// export const RETIREMENT_DATE = "2025-04-29T00:00:00Z";

export const ARENA_LOBBY_SIZE = 16;

export const SUBTEAMS = {
  0: {
    icon: null,
    name: ["lol:subteams.invalid", "Riot failed to report teams"],
    color: "var(--blue)",
  },
  1: {
    icon: null,
    name: ["lol:subteams.poro", "Poro"],
    color: "var(--pink)",
  },
  2: {
    icon: null,
    name: ["lol:subteams.minion", "Minion"],
    color: "var(--turq)",
  },
  3: {
    icon: null,
    name: ["lol:subteams.scuttle", "Scuttle"],
    color: "var(--green)",
  },
  4: {
    icon: null,
    name: ["lol:subteams.krug", "Krug"],
    color: "var(--orange)",
  },
  5: {
    icon: null,
    name: ["lol:subteams.raptor", "Raptor"],
    color: "var(--red)",
  },
  6: {
    icon: null,
    name: ["lol:subteams.sentinel", "Sentinel"],
    color: "var(--blue)",
  },
  7: {
    icon: null,
    name: ["lol:subteams.wolf", "Wolf"],
    color: "var(--yellow)",
  },
  8: {
    icon: null,
    name: ["lol:subteams.gromp", "Gromp"],
    color: "var(--purple)",
  },
};

export const PLACEMENT_ORDINALS = {
  0: {
    short: ["lol:notAvailable", "N/A"],
    long: ["common:placementOrdinals.notAvailable.long", "N/A Place"],
  },
  1: {
    short: ["common:placementOrdinals.first.short", "1st"],
    long: ["common:placementOrdinals.first.long", "1st Place"],
  },
  2: {
    short: ["common:placementOrdinals.second.short", "2nd"],
    long: ["common:placementOrdinals.second.long", "2nd Place"],
  },
  3: {
    short: ["common:placementOrdinals.third.short", "3rd"],
    long: ["common:placementOrdinals.third.long", "3rd Place"],
  },
  4: {
    short: ["common:placementOrdinals.fourth.short", "4th"],
    long: ["common:placementOrdinals.fourth.long", "4th Place"],
  },
  5: {
    short: ["common:placementOrdinals.fifth.short", "5th"],
    long: ["common:placementOrdinals.fifth.long", "5th Place"],
  },
  6: {
    short: ["common:placementOrdinals.sixth.short", "6th"],
    long: ["common:placementOrdinals.sixth.long", "6th Place"],
  },
  7: {
    short: ["common:placementOrdinals.seventh.short", "7th"],
    long: ["common:placementOrdinals.seventh.long", "7th Place"],
  },
  8: {
    short: ["common:placementOrdinals.eighth.short", "8th"],
    long: ["common:placementOrdinals.eighth.long", "8th Place"],
  },
};

export const ARENA_RANK_SYMBOLS = stringsToSymbols([
  "orange",
  "purple",
  "blue",
  "green",
  "gray",
]);

export const ARENA_RANK_SYMBOL_TO_STR = new SymbolMap({
  [ARENA_RANK_SYMBOLS.orange]: {
    key: "gladiator",
    gql: "ORANGE",
    t: {
      name: "lol:filters.ranks.gladiator",
      fallback: "Gladiator",
    },
  },
  [ARENA_RANK_SYMBOLS.purple]: {
    key: "gold",
    gql: "PURPLE",
    t: {
      name: "lol:filters.ranks.gold",
      fallback: "Gold",
    },
  },
  [ARENA_RANK_SYMBOLS.blue]: {
    key: "silver",
    gql: "BLUE",
    t: {
      name: "lol:filters.ranks.silver",
      fallback: "Silver",
    },
  },
  [ARENA_RANK_SYMBOLS.green]: {
    key: "bronze",
    gql: "GREEN",
    t: {
      name: "lol:filters.ranks.bronze",
      fallback: "Bronze",
    },
  },
  [ARENA_RANK_SYMBOLS.gray]: {
    key: "wood",
    gql: "GRAY",
    t: {
      name: "lol:filters.ranks.wood",
      fallback: "Wood",
    },
  },
});

export const RANDOM_ITEM_TYPES = {
  fighter: 220001,
  marksman: 220002,
  assassin: 220003,
  mage: 220004,
  tank: 220005,
  support: 220006,
};

export const SWEEPER = 3348;
export const STARTERS = {
  222051: true,
  2049: true,
  2050: true,
  223112: true,
  223177: true,
  223185: true,
  223184: true,
};
export const EARLY_ITEMS = {
  223121: true,
  223042: true,
  223040: true,
};

export const BUILD_FORMAT = {
  key: null,
  games: 0,
  wins: 0,
  runes: [],
  rune_shards: [],
  summoner_spells: [],
  items_starting: [],
  items_completed: [],
  items_situational: [],
  items_boots: [],
  items_order: [],
  skills: [],
  stats: {
    runes: {},
    items: {},
    summoners: {},
  },
  misc: {
    playstyleTitle: null,

    // MATCHUPS AND PROBUILDS
    opponentChampion: null,

    // PROBUILDS
    gameId: null,
    player: null,
    patch: null,
    insertedAt: null,
  },
};
